export const MAX_BANK_RECEIPT_BYTES = 5 * 1024 * 1024;

export const BANK_TRANSFER_REJECTION_LABELS = {
  payment_not_found: "Payment not found",
  amount_mismatch: "Payment amount does not match",
  reference_mismatch: "Payment reference does not match",
  unreadable_receipt: "Receipt is unreadable",
  duplicate_receipt: "Receipt was already submitted",
  invalid_or_altered_receipt: "Receipt is invalid or appears altered",
  other: "Other",
};

export const getStoredCheckoutPlan = (storedPlan) => {
  if (!storedPlan) return null;

  try {
    const parsed = JSON.parse(storedPlan);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (_error) {
    return null;
  }
};

export const isBankTransferEligible = ({ userData, plan, payableAmount }) =>
  Number(userData?.PortalId) === 1 &&
  plan?.UsersCountry === "PK" &&
  Number(payableAmount) > 0;

const parseJsonObject = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;

  try {
    return JSON.parse(value);
  } catch (_error) {
    return null;
  }
};

export const buildBankTransferConfirmation = (apiResult, fallback = {}) => ({
  transactionId: apiResult?.response?.transactionId || "",
  referenceNumber:
    apiResult?.response?.referenceNumber || fallback.referenceNumber || "",
  status: apiResult?.response?.status || "pending",
  planName: fallback.planName || "Subscription plan",
});

export const normalizeBankTransferApiStatus = (payload) => {
  if (Number(payload?.responseCode) !== 200 || !payload?.response) return null;
  return payload.response;
};

export const isBankTransferPurchaseLocked = (status) =>
  status?.status === "pending" || status?.purchaseLocked === true;

export const getPendingBankTransferFromError = (error) => {
  if (Number(error?.response?.status) !== 409) return null;
  const status = error?.response?.data?.response;
  return status?.status === "pending" ? status : null;
};

export const normalizePaymentHistoryTransaction = (transaction) => {
  const responsePayload = parseJsonObject(transaction?.ResponsePayload);
  const parsedCurrency = parseJsonObject(transaction?.Currency);
  const currency =
    typeof parsedCurrency === "string" ? parsedCurrency : transaction?.Currency || "";
  const amount = transaction?.TransactionAmount;

  return {
    id: transaction?.TransactionId || "N/A",
    date: responsePayload?.TransactionDateTime || transaction?.CreatedAt || "N/A",
    items: transaction?.SubscriptionName || "N/A",
    status: transaction?.TransactionStatus || transaction?.Status || "N/A",
    amount: amount != null && String(amount).trim() !== '' ? `${currency} ${amount}`.trim() : "N/A",
    reviewReason: transaction?.ReviewReasonCode
      ? BANK_TRANSFER_REJECTION_LABELS[transaction.ReviewReasonCode] || "Other"
      : null,
    reviewRemarks: transaction?.ReviewRemarks || null,
    reviewedAt: transaction?.ReviewedAt || null,
  };
};
